import React from 'react';
import workspaceQuery from '../../queries/purchases/PurchaseOrderWorkspaceQuery.graphql';
import listQuery from '../../queries/purchases/PurchaseOrderListQuery.graphql';
import instanceQuery from '../../queries/purchases/PurchaseOrderQuery.graphql';
import temporaryQuery from '../../queries/purchases/PurchaseOrderTempQuery.graphql';
import defaultQuery from '../../queries/purchases/PurchaseOrderDefault.graphql';
import mutationQuery from '../../mutations/purchases/PurchaseOrderMutation.graphql';
import aggregateQuery from '../../queries/purchases/PurchaseOrderAggregateQuery.graphql';
import fragment from '../../fragments/purchases/PurchaseOrderFragment.graphql';
import temporaryMutationQuery from '../../mutations/purchases/SaveOrderTempMutation.graphql';

import { formActionsForPermissions } from '../../../actions/purchasing/PurchaseOrderAction';
import { workspaceForPermission } from '../../../actions/purchasing/PurchaseOrderWorkspaceAction';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';
import { IPurchaseOrder } from '../../schema/p4types';
import { orRemoteFilterGetter } from '../../../utils/OrRemoteFilterGetter';

const PurchaseOrderOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: IPurchaseOrder }) => {
  const orderReferenceLabel = option.orderReference ? ` - ${option.orderReference}` : '';
  const supplierNameLabel = option.supplier?.name ? ` - ${option.supplier.name}` : '';

  return (
    <span>
      {option.orderNumber}
      {orderReferenceLabel}
      {supplierNameLabel}
    </span>
  );
};

const PurchaseOrder: EntityType = {
  type: 'PurchaseOrder',
  title: 'Purchase Orders',
  formUrl: '/Purchasing/Order/Details/',
  formTitle: 'Purchase Orders',
  workspaceUrl: '/Purchasing/Order/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  temporary: temporaryQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderNumber',
    optionRenderer: PurchaseOrderOptionRenderer,
    remoteFilter: true,
    remoteFilterGetter: orRemoteFilterGetter(['orderNumber', 'orderReference', 'supplier.name']),
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'PURCHASING_ORDERS',
  actions: [...formActionsForPermissions, ...workspaceForPermission],
};

export default PurchaseOrder;
